
































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import SearchInput from "@/components/searchInput.vue";

@Component({
    name: 'index',
    components: {SearchInput, basicPage}
})
export default class index extends basicPage {
    //所有热词（排序好的）
    allHotKeyWords: string[] = [];

    //自动补全词库
    autoCompleteDataSources: string[] = [];

    //所有的导航信息
    navList: object[] = [
        {
            routerName: 'knowledgeBase',
            text: '知识库',
            icon: '/img/icons/knowledgeBase_icon.png',
            desc: '快速找到所需知识、文档'
        },
        {
            routerName: 'QA',
            text: 'Q & A',
            icon: '/img/icons/QA_icon.png',
            desc: '遇到问题，轻松解决'
        },
        {
            routerName: 'train',
            text: '培训报名',
            icon: '/img/icons/register_icon.png',
            desc: '定期培训实时了解'
        },
        {
            routerName: 'askQuestion',
            text: '我要提问',
            icon: '/img/icons/query_icon.png',
            desc: '发布问题，集思广益'
        }
    ];

    handelNavigate(routerName: string = 'globalList', params?: any) {
        if (routerName === 'askQuestion') {
            params = {
                queryParams: JSON.stringify({
                    skip: true
                })
            };
        }
        this.$router.push({name: routerName, params});
    }

    //获取热门关键字
    fetchHotKeyWords() {
        ajaxHelperInstance.get('/web/record/getHot', {}, undefined, this).then((res) => {
            let {status, data} = res;
            if (status === 200) {
                let hotKeyWords = data.data || [];
                this.allHotKeyWords = hotKeyWords.sort((curWord, nextWord) => nextWord.weight - curWord.weight).map(word => word.text).slice(0, 10);
            }
        });
    }

    //自动补全
    handleAutoComplete(inputVal: string) {
        if (inputVal) {
            ajaxHelperInstance.get('/web/record/findList', {content: inputVal}, undefined, this).then((res) => {
                let {status, data} = res;
                if (status === 200) {
                    let hotKeyWords = data.data || [];
                    this.autoCompleteDataSources = hotKeyWords.map(word => word.content);
                }
            });
        } else {
            this.autoCompleteDataSources = [];
        }
    }

    //搜索关键字
    handleSearch(inputVal: string) {
        if (inputVal) {
            //跳到搜索页
            this.handelNavigate('query', {keywords: inputVal});
        }
    }

    init() {
        this.fetchHotKeyWords();
        //默认路由
        this.$router.push({name: 'globalList'});
    }

    mounted() {
        this.init();
    }
}
